import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../components/Table";
import AccountLayout from "../../blocs/AccountLayout";
import ReponseComment from "./ReponseComment";
import {
  fetchReviews,
  selectReviews,
  selectAverageRating,
  selectPagination,
} from "../../store/slices/avisSlice";
import RendezVousSkeleton from "../../components/skeletons/RendezVousSkeleton";

function AvisClient() {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const dispatch = useDispatch();

  // Sélecteurs
  const reviews = useSelector(selectReviews);
  const pagination = useSelector(selectPagination);
  //const status = useSelector((state) => state.status);
  const error = useSelector((state) => state.error);
  const { user } = useSelector((state) => state.user);
  const idEtablissement = user?.etablissement?.id;
  const {status } = useSelector((state) => state.avisClient.reviews);
  const [currentPage, setCurrentPage] = useState(1);
  //  console.log("reviews",reviews)
  //  console.log("selectReviews",selectReviews)
  useEffect(() => {
    if (idEtablissement) {
      dispatch(fetchReviews({ idEtablissement, page: currentPage }));
    }
  }, [dispatch, idEtablissement, currentPage]);

  const handleResponse = (e, review) => {
    e.stopPropagation();
    setSelectedReview(review);
    setPopupVisible(true);
  };

  const columns = [
    { Header: "Date de réservation", accessor: "dateReservation" },
    { Header: "Prestation", accessor: "prestation" },
    { Header: "Client", accessor: "client" },
    { Header: "Note", accessor: "note" },
    { Header: "Commentaire", accessor: "comment" },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <button
          onClick={(e) => {
            handleResponse(e, row.original);
            // console.log("row.original",row.original);
          }}
          className="no-outline"
        >
          <img src="/images/comment.svg" alt="comment" />
        </button>
      ),
    },
  ];

  const data = useMemo(() => {
    return reviews?.map((review) => ({
      id: review?.id,
      dateReservation: review?.appointment?.start_time
        ? new Date(review.appointment.start_time).toLocaleDateString()
        : "",
      heureReservation: review?.appointment?.start_time
        ? review?.appointment?.start_time
        : "",
      prestation: review?.appointment?.prestations_snapshot[0]?.name || "",
      client: `${review?.user?.nom || ""} ${review?.user?.prenom || ""}`,
      note: review?.rating ? `${review.rating}/5` : "",
      comment: review?.comment || "",
      actions: "",
    }));
  }, [reviews]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <>
      <AccountLayout bgColor={"bgColor"}>
        <h3 className="mb-24">Avis clients</h3> {status}
        {status === "loading" ? (
          <RendezVousSkeleton />
        ) : status === "succeeded" && reviews.length === 0 ? (
          <p>Aucun avis disponible.</p>
        ) : (
         data?.length == 0 ? (
          <></>
        ) : (
          <Table
            columns={columns}
            data={data}
            currentPage={pagination.currentPage}
            totalPages={pagination.lastPage}
            onPageChange={handlePageChange}
          />
        )
        )}



        {/* )} */}
      </AccountLayout>

      {isPopupVisible && (
        <ReponseComment
          isPopupVisible={isPopupVisible}
          setPopupVisible={setPopupVisible}
          review={selectedReview}
        />
      )}
    </>
  );
}

export default AvisClient;
